import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Menu } from 'components/menu/containers/menu';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useBreakpointValue } from 'utils/mediaQuery';
import { pubSub } from 'utils/pubSub';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { OrganizationsNavigation } from './components/organizationsNavigation/organizationsNavigation';
import styles from './navigation.module.scss';
/** Left side main app layout navigation component */
export const Navigation = () => {
    const { organizationsSidebar } = useFeatureFlag(['organizations-sidebar']);
    const organizations = useAppSelector((state) => state.app.organizations);
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        setIsOpen(false);
    }, [isSmallScreen]);
    useEffect(() => {
        const unsubscribe = pubSub.subscribe('toggleNavigation', ({ isOpen }) => {
            setIsOpen(isOpen !== null && isOpen !== void 0 ? isOpen : !isOpen);
        });
        return () => unsubscribe();
    }, []);
    const handleToggleNavigation = () => {
        setIsOpen(!isOpen);
    };
    return (_jsxs("div", Object.assign({ className: classNames(styles.navigationContainer, {
            [styles.navigationContainerOpen]: isOpen,
        }) }, { children: [isSmallScreen && (_jsx(Box, { className: styles.backdrop, "aria-hidden": "true", onClick: () => setIsOpen(false) })), _jsxs("div", Object.assign({ className: styles.navigation }, { children: [organizationsSidebar && organizations.length > 1 && (_jsx(OrganizationsNavigation, { className: styles.sidebar })), _jsx("div", Object.assign({ className: styles.menu }, { children: _jsx(Menu, { isMenuAlwaysOpen: !!isSmallScreen, onToggleNavigation: handleToggleNavigation }) }))] }))] })));
};
